import { reducerCloseChatbox } from "app/redux/chats&notifications/reducers/sidebar/reducerCloseChatbox";

export const reducerOpenChatbox = (state, { chatId }) => ({
  ...state,
  chatboxes: [
    ...reducerCloseChatbox(state, {chatId}).chatboxes,
    { id: chatId, open: true }
  ],
})
